import React, { useCallback, useMemo } from "react";
import { createContext, useContext, useState } from "react";
import { focusManager } from "../utils/Focus";
import { InfoModal } from "../components/views/modals/InfoModal";
import { useTranslation } from "react-i18next";
import { getModalText } from "../utils/Helpers";
var ModalContext = createContext(null);
export var ModalProvider = function (_a) {
    var children = _a.children;
    var _b = useState(null), modal = _b[0], setModal = _b[1];
    var t = useTranslation().t;
    var showModal = useCallback(function (type) {
        setModal(function (current) {
            if (current)
                return current;
            focusManager.pushLayer({ groupName: "modalView", index: 0 });
            return type;
        });
    }, []);
    var hideModal = useCallback(function () {
        focusManager.popLayer();
        setModal(null);
    }, []);
    var value = useMemo(function () { return ({ showModal: showModal, hideModal: hideModal }); }, [showModal, hideModal]);
    return (React.createElement(ModalContext.Provider, { value: value },
        children,
        modal && React.createElement(InfoModal, { text: getModalText(modal, t), onClose: hideModal })));
};
export var useModalContext = function () {
    var context = useContext(ModalContext);
    if (!context) {
        throw new Error("useModalContext must be used within ModalProvider");
    }
    return context;
};



//////////////////
// WEBPACK FOOTER
// ./src/context/ModalContext.tsx
// module id = 11
// module chunks = 1